module.exports = __webpack_public_path__ + "static/media/adicionaEmpresaRegister.9b111ec2.jpg";